import { driverAssets } from '../constants/assets'
import type {
  DriverAvailability,
  DriverLanguage,
  DriverRecord,
  VehicleCategory,
} from '../types'

export const driverAvailabilities: DriverAvailability[] = [
  'available',
  'on-trip',
  'on-break',
  'offline',
]

export const driverAvailabilityLabels: Record<DriverAvailability, string> = {
  available: 'Available',
  'on-trip': 'On trip',
  'on-break': 'On Break',
  offline: 'Offline',
}

export const vehicleCategories: VehicleCategory[] = [
  'Standard Saloon',
  'Premium Saloon',
  'Economy Van',
  'Premium van',
  'Business Van',
  'Minibus',
]

export const driverLanguages: DriverLanguage[] = [
  'English',
  'German',
  'English & German',
  'English & Italian',
]

const driverProfiles = [
  { name: 'Amal Ahammed', email: 'amal.driver@salzburgcab.com', phone: '+43 660 123 4567', vehicle: 'Standard Saloon' as const, plate: 'AT-548796', code: 'DRV-1024', exp: 12 },
  { name: 'Marco Rossi', email: 'marco.rossi@salzburgcab.com', phone: '+43 660 234 5678', vehicle: 'Premium Saloon' as const, plate: 'AT-982143', code: 'DRV-1025', exp: 8 },
  { name: 'Stefan Weber', email: 'stefan.weber@salzburgcab.com', phone: '+43 660 345 6789', vehicle: 'Business Van' as const, plate: 'AT-334190', code: 'DRV-1026', exp: 10 },
  { name: 'Lukas Müller', email: 'lukas.mueller@salzburgcab.com', phone: '+43 660 456 7890', vehicle: 'Economy Van' as const, plate: 'AT-771245', code: 'DRV-1027', exp: 6 },
  { name: 'Elena Fischer', email: 'elena.fischer@salzburgcab.com', phone: '+43 660 567 8901', vehicle: 'Premium van' as const, plate: 'AT-665219', code: 'DRV-1028', exp: 9 },
  { name: 'Thomas Huber', email: 'thomas.huber@salzburgcab.com', phone: '+43 660 678 9012', vehicle: 'Minibus' as const, plate: 'AT-881940', code: 'DRV-1029', exp: 14 },
  { name: 'David Berger', email: 'david.berger@salzburgcab.com', phone: '+43 660 789 0123', vehicle: 'Standard Saloon' as const, plate: 'AT-213456', code: 'DRV-1030', exp: 7 },
  { name: 'Michael Steiner', email: 'michael.steiner@salzburgcab.com', phone: '+43 660 890 1234', vehicle: 'Premium Saloon' as const, plate: 'AT-445890', code: 'DRV-1031', exp: 11 },
]

/**
 * Stand-in roster mirroring the placeholder card in the design. The availability cycle
 * reproduces the order shown in Figma for the rows that are visible on load.
 */
const availabilityCycle: DriverAvailability[] = [
  'available',
  'on-trip',
  'available',
  'offline',
  'available',
  'on-trip',
  'offline',
]

/** The design's header reads "Available Drivers(128)", so the roster is that long. */
export const DRIVER_COUNT = 128

export const drivers: DriverRecord[] = Array.from({ length: DRIVER_COUNT }, (_, index) => {
  const profile = driverProfiles[index % driverProfiles.length]
  return {
    id: `driver-${index + 1}`,
    code: profile.code,
    name: profile.name,
    email: profile.email,
    phone: profile.phone,
    avatar: driverAssets.avatar,
    vehicle: { category: profile.vehicle, plate: profile.plate },
    incomeEur: 250 + (index % 5) * 45,
    experienceYears: profile.exp,
    language: (index % 3 === 0 ? 'English & German' : index % 3 === 1 ? 'German' : 'English') as DriverLanguage,
    availability: availabilityCycle[index % availabilityCycle.length],
  }
})
